import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import TicketTypesManager from '../../components/TicketTypesManager';

const TicketTypesPage = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  if (!eventId) {
    return (
      <div className="p-6 text-sm text-red-500">
        No event selected.
      </div>
    );
  }

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-6">
      <div className="flex items-center gap-3">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1 text-sm text-[#1672b9] hover:underline"
        >
          <ArrowLeftIcon className="w-4 h-4" />
          Back
        </button>
      </div>

      <div>
        <h1 className="text-2xl font-bold text-gray-900">
          Ticket Types
        </h1>
        <p className="text-sm text-gray-500 mt-1">
          Manage ticket categories for this event
        </p>
      </div>

      <TicketTypesManager eventId={eventId} />
    </div>
  );
};

export default TicketTypesPage;